import React, { useState } from "react";
import { Card, Form, Row, Col, Button, Container, InputGroup } from "react-bootstrap";
import { Line } from "react-chartjs-2";
import "chart.js/auto";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { FaMoneyBillWave, FaPercentage, FaCalendarAlt } from "react-icons/fa";

const LoanCalculator = () => {
  const [loanType, setLoanType] = useState("Personal Loan");
  const [amount, setAmount] = useState(500000);
  const [interest, setInterest] = useState(12);
  const [years, setYears] = useState(5);
  const [monthlyPayment, setMonthlyPayment] = useState(0);
  const [totalInterest, setTotalInterest] = useState(0);
  const [totalPayment, setTotalPayment] = useState(0);
  const [schedule, setSchedule] = useState([]);

  const loanTypes = {
    " ASSET FINANCE": 12,
    " DEVELOPMENT LOAN": 12,
    " DIVIDEND ADVANCE": 0,
    "EMERGENCY LOAN": 12,
    " INSTANT LOAN": 4.5,
    " INVESTMENT LOAN": 14,
    " SCHOOL FEES LOAN": 12,
    " PLOT PURCHASE LOAN": 14,
  };

  const handleLoanTypeChange = (e) => {
    const selectedType = e.target.value;
    setLoanType(selectedType);
    setInterest(loanTypes[selectedType]);
  };

  const calculateLoan = () => {
    const principal = amount;
    const calculatedInterest = interest / 100 / 12;
    const totalMonths = years * 12;
    const x = Math.pow(1 + calculatedInterest, totalMonths);
    const monthly = (principal * x * calculatedInterest) / (x - 1);

    const totalPay = monthly * totalMonths;
    const totalInt = totalPay - principal;

    setMonthlyPayment(monthly.toFixed(2));
    setTotalPayment(totalPay.toFixed(2));
    setTotalInterest(totalInt.toFixed(2));

    let balance = principal;
    let scheduleArr = [];
    for (let i = 1; i <= totalMonths; i++) {
      let interestPaid = balance * calculatedInterest;
      let principalPaid = monthly - interestPaid;
      balance -= principalPaid;
      scheduleArr.push({ month: i, principalPaid, interestPaid, balance });
    }
    setSchedule(scheduleArr);
  };


  return (
    <>
      <Navbar />
      <div className="loan-container">
        {/* Simulated Phone Frame */}
        <div className="phone-frame">
          <div className="phone-screen">
            <Container>
              <Card className="loan-card">
                <h2 className="text-center loan-heading">💰 Loan Calculator</h2>
                <Form className="loan-form">
                  <Row className="mb-2">
                  <Col xs={12}>
  <Form.Group>
    <Form.Label>Loan Type</Form.Label>
    <InputGroup>
      <InputGroup.Text><FaPercentage /></InputGroup.Text> {/* Icon inside input */}
      <Form.Control
        as="select"
        value={loanType}
        onChange={handleLoanTypeChange}
        className="form-select-visible"
      >
        <option value="">Select Loan Type</option>
        {Object.keys(loanTypes).map((type) => (
          <option key={type} value={type}>{type}</option>
        ))}
      </Form.Control>
    </InputGroup>
  </Form.Group>
</Col>






                    <Col xs={12}>
                      <Form.Group>
                        <Form.Label>Interest Rate (%)</Form.Label>
                        <InputGroup>
                          <InputGroup.Text><FaPercentage /></InputGroup.Text>
                          <Form.Control type="number" value={interest} readOnly />
                        </InputGroup>
                      </Form.Group>
                    </Col>
                    <Col xs={12}>
                      <Form.Group>
                        <Form.Label>Loan Amount (KES)</Form.Label>
                        <InputGroup>
                          <InputGroup.Text><FaMoneyBillWave /></InputGroup.Text>
                          <Form.Control
                            type="number"
                            value={amount}
                            onChange={(e) => setAmount(e.target.value)}
                          />
                        </InputGroup>
                      </Form.Group>
                    </Col>
                    <Col xs={12}>
                      <Form.Group>
                        <Form.Label>Loan Term (Years)</Form.Label>
                        <InputGroup>
                          <InputGroup.Text><FaCalendarAlt /></InputGroup.Text>
                          <Form.Control
                            type="number"
                            value={years}
                            onChange={(e) => setYears(e.target.value)}
                          />
                        </InputGroup>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Button variant="primary" onClick={calculateLoan} className="w-100 fancy-button">
                    🧮 Calculate
                  </Button>
                </Form>

                {monthlyPayment > 0 && (
                  <div className="mt-3 text-center loan-results">
                    <h5>📊 Monthly: <strong>KES {monthlyPayment}</strong></h5>
                    <h6>💰 Total Interest: <strong>KES {totalInterest}</strong></h6>
                    <h6>🛒 Total Payment: <strong>KES {totalPayment}</strong></h6>
                  </div>
                )}

               
              </Card>
            </Container>
          </div>
        </div>
      </div>
      <Footer />

      <style>
        {`
         .loan-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: calc(100vh - 100px); /* Adjusts height dynamically */
  padding: 20px 0; /* Adds spacing */
  background: #f8f9fa;
}
.form-select-visible {
  background-color: #f0f0f0 !important; /* Light grey like the input field */
  border: 1px solid #ccc;
  color: #333;
  padding: 10px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.form-select-visible:focus {
  outline: none;
  border-color: #007bff;
  background-color: #e0e0e0; /* Slightly darker on focus */
}

.phone-frame {
  width: 300px; /* Slightly smaller */
  height: 550px; /* Reduced height */
  background: #000;
  border-radius: 25px;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  margin-top: 70px; /* Prevents touching navbar */
  margin-bottom: 20px; /* Prevents touching footer */
}

.phone-screen {
  width: 92%;
  height: 95%;
  background: white;
  border-radius: 20px;
  overflow-y: auto;
  padding: 10px;
}


          .loan-card {
            border-radius: 12px;
            box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
            border: none;
            padding: 15px;
            background: white;
          }

          .loan-heading {
            color: #007bff;
            font-size: 1.2rem;
            font-weight: bold;
          }

          .fancy-button {
            background: linear-gradient(135deg, #007bff, #0056b3);
            border: none;
            padding: 8px;
            border-radius: 10px;
            font-weight: bold;
            transition: all 0.3s ease-in-out;
          }

          .fancy-button:hover {
            background: linear-gradient(135deg, #0056b3, #003b82);
            transform: translateY(-2px);
          }

          .loan-results {
            background: rgba(248, 249, 250, 0.8);
            padding: 8px;
            border-radius: 8px;
          }
.loan-form input {
  background-color: #f0f0f0 !important; /* Light grey */
  border: 1px solid #ccc;
  color: #333;
  padding: 10px;
  transition: all 0.3s ease;
  caret-color: black; /* Cursor color */
}

.loan-form input:focus {
  outline: none;
  border-color: #007bff;
  background-color: #e0e0e0; /* Slightly darker grey on focus */
}

/* Blinking cursor effect */
.loan-form input::placeholder {
  opacity: 1;
  transition: opacity 0.5s ease-in-out;
  animation: blink 1s infinite;
}

@keyframes blink {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.4; }
}

          .loan-chart {
            max-width: 100%;
            overflow-x: auto;
          }
        `}
      </style>
    </>
  );
};

export default LoanCalculator;
